

import { Deep } from '@brg/toolbox';

export const themes: Record<string, any> = {
    dark: {
        mainMenu: {
            iconColor: '#FEFEFE',
            lineColor: 'rgba(254,254,254, 0.21)',

            backgroundColorNoBlur: '#151514',
            backgroundColor: 'rgba(21,21,20, 0.71)',
            activeColor: '#FFFFFF',
            textColor: 'rgba(254,254,254, 0.71)',
            button: {
                borderColor: '#F1DB63',
                textColor: '#FEFEFE',
            },
        },
    },
    white: {
        mainMenu: {
            iconColor: '#151514',
            lineColor: 'rgba(21,21,20, 0.13)',

            backgroundColorNoBlur: '#FEFEFE',
            backgroundColor: 'rgba(254,254,254, 0.71)',
            activeColor: 'rgba(21,21,20, 1)',
            textColor: 'rgba(21,21,20, 0.71)',
            button: {
                borderColor: 'rgba(31,31,31, 0.31)',
                textColor: 'rgba(21,21,20, 1)',
            },
        },
    },
    grey: {
        mainMenu: {
            iconColor: '#FEFEFE',
            lineColor: 'rgba(254,254,254, 0.21)',

            backgroundColor: 'rgba(42, 48, 52, 0.71)',
            backgroundColorNoBlur: '#2A3034',
            activeColor: '#FFFFFF',
            textColor: 'rgba(254,254,254, 0.71)',
            button: {
                borderColor: '#A4B54D',
                textColor: '#FEFEFE',
            },
        },
    },
};

export type MainMenuColorTheme = 'dark' | 'grey' | 'white' | 'light' | 'gray' | 'black';

/**
 * Returns the theme data
 *
 * @param name
 * @constructor
 */
export default function GetMainMenuTheme(name: MainMenuColorTheme) {
    let rName = name;
    if (rName === 'light') rName = 'white';
    if (rName === 'gray') rName = 'grey';
    if (rName === 'black') rName = 'dark';
    return Deep.merge(themes.dark, themes[rName]);
}


import { Deep } from '@brg/toolbox';

export const themes: Record<string, any> = {
    dark: {
        mainMenu: {
            iconColor: '#FEFEFE',
            lineColor: 'rgba(254,254,254, 0.21)',

            backgroundColorNoBlur: '#151514',
            backgroundColor: 'rgba(21,21,20, 0.71)',
            activeColor: '#FFFFFF',
            textColor: 'rgba(254,254,254, 0.71)',
            button: {
                borderColor: '#F1DB63',
                textColor: '#FEFEFE',
            },
        },
    },
    white: {
        mainMenu: {
            iconColor: '#151514',
            lineColor: 'rgba(21,21,20, 0.13)',

            backgroundColorNoBlur: '#FEFEFE',
            backgroundColor: 'rgba(254,254,254, 0.71)',
            activeColor: 'rgba(21,21,20, 1)',
            textColor: 'rgba(21,21,20, 0.71)',
            button: {
                borderColor: 'rgba(31,31,31, 0.31)',
                textColor: 'rgba(21,21,20, 1)',
            },
        },
    },
    grey: {
        mainMenu: {
            iconColor: '#FEFEFE',
            lineColor: 'rgba(254,254,254, 0.21)',

            backgroundColor: 'rgba(42, 48, 52, 0.71)',
            backgroundColorNoBlur: '#2A3034',
            activeColor: '#FFFFFF',
            textColor: 'rgba(254,254,254, 0.71)',
            button: {
                borderColor: '#A4B54D',
                textColor: '#FEFEFE',
            },
        },
    },
};

export type MainMenuColorTheme = 'dark' | 'grey' | 'white' | 'light' | 'gray' | 'black';

/**
 * Returns the theme data
 *
 * @param name
 * @constructor
 */
export default function GetMainMenuTheme(name: MainMenuColorTheme) {
    let rName = name;
    if (rName === 'light') rName = 'white';
    if (rName === 'gray') rName = 'grey';
    if (rName === 'black') rName = 'dark';
    return Deep.merge(themes.dark, themes[rName]);
}
